import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/balance";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { persistStore } from "redux-persist";
import storage from "redux-persist/es/storage";

import loginReducer from "../features/auth/reducer/loginReducer";
import userDetailsReducer from "../features/auth/reducer/userReducer";
import purseStatReducer from "../features/purse/reducer/purseStatReducer";
import userStatReducer from "../features/user/reducer/userStatReducer";
import publicCliqReducer from "../features/auth/reducer/publicCliqReducer";
import userNotificationsReducer from "../features/user/reducer/userNotificationsReducer";
// State Persistence for the whitelisted states
export const rootReducer = combineReducers({
  userBalance: userReducer,
  auth: loginReducer,
  userDetails: userDetailsReducer,
  purseDetails: purseStatReducer,
  myStat: userStatReducer,
  publicCliqs: publicCliqReducer,
  userNotifications: userNotificationsReducer,
});

const config = {
  key: "hervest-reducers",
  storage,
};

const persistedRootReducer = persistReducer(config, rootReducer);

// MiddleWare Implementation and State Management
export const store = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

//State Persistence for the entire state
export const persiststore = persistStore(store);
